import React from 'react';
interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  tone?: 'light' | 'dark';
  align?: 'left' | 'center';
}
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  tone = 'light',
  align = 'center'
}: SectionHeadingProps) {
  const isDark = tone === 'dark';
  return <div className={['max-w-3xl', align === 'center' ? 'mx-auto text-center' : 'text-left'].join(' ')} data-id="element-244" data-mp="3k18au7gl9uk7">
      {eyebrow ? <p className={['font-display text-[0.7rem] font-700 uppercase tracking-[0.2em] sm:text-xs', isDark ? 'text-gold-400' : 'text-teal-600'].join(' ')} data-id="element-245" data-mp="gj6uf9x23bif">
          {eyebrow}
        </p> : null}
      <h2 className={['mt-2 font-display text-2xl font-800 leading-[1.1] sm:mt-3 sm:text-4xl lg:text-[2.75rem]', isDark ? 'text-cream-50' : 'text-teal-900'].join(' ')} data-id="element-246" data-mp="6ru1sg3fohbc">
        {title}
      </h2>
      {subtitle ? <p className={['mt-2 text-sm leading-relaxed sm:mt-4 sm:text-lg', isDark ? 'text-cream-100/80' : 'text-clay'].join(' ')} data-id="element-247" data-mp="1t961jj0a4zdj">
          {subtitle}
        </p> : null}
    </div>;
}